import ForgotPasswordForm from "../../forms/ForgotPasswordForm";

export default function ForgotPassword() {
  return <ForgotPasswordForm />;
}
